/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import proPropTypes from '../../../../utilities/proPropTypes';

import styles from '../VehicleCards.module.scss';

const NotInteractiveVehicleCard = ({
	children = null,
	className = '',
	loading = false,
	loadingView = null,
	vehicle = {},
}) => {
	const baseClassName = cx(styles.vehicleCardContainer, className);

	if (loading) {
		return <div className={cx(styles.vehicleCardLoading, baseClassName)}>{loadingView}</div>;
	}

	const { id } = vehicle;

	return (
		<div className={cx('mw-i', baseClassName)} id={`vehicle_card_${id}`}>
			{children}
		</div>
	);
};

NotInteractiveVehicleCard.propTypes = {
	children: PropTypes.node,
	className: proPropTypes.className,
	loading: PropTypes.bool,
	loadingView: PropTypes.node,
	vehicle: PropTypes.oneOfType([proPropTypes.vehicleCardList, proPropTypes.accountVehicle]),
};

export default NotInteractiveVehicleCard;
